module.exports = __webpack_public_path__ + "img/pc_banner_sup_recommend.0286b462.webp";